const DESIGNATIONS = ["Please Select", "Employe", "Staff", "Teacher"]
const GENDER = ["Select Gender", "MALE", "FEMALE"]
const MARITAL_STATUS = ["Select one", "MARRIED", "UN_MARRIED"]



export { DESIGNATIONS, GENDER, MARITAL_STATUS }